module.exports = __webpack_public_path__ + "media/images/writer/community/pc-headline-about-community@3x-b78ca841984a67376e136ede1cec78ea.png";